export default __webpack_public_path__ + "static/media/kraken.76ceb351.svg";